import { PureComponent } from "react";
import * as React from "react";
import Loadable from "react-loadable";

const Loading = () => null;

const SocialContainer = Loadable({
    loader: () => import('./views/SocialView'),
    loading: Loading
});

export default class SocialsView extends PureComponent {

    render() {

        let { socials, logo } = this.props;

        return (
            <div className="socials">
                <nav>
                    {socials &&
                    <ul data-text="true">
                        {socials.map((social, index) => (
                            <SocialContainer data={ social } key={index} />
                        ))}
                        {!this.props.menu &&
                        <li>
                            <a href="https://www.habitat-en-region.fr/" target="_blank">
                                <img src={logo.carre}/>
                                <span>Habitat en région</span>
                            </a>
                        </li>
                        }
                    </ul>
                    }
                </nav>
            </div>
        )
    }
}
